import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Mashy from "@/components/Mashy";
import { MASHY } from "@/lib/api";

export default function Splash() {
  const nav = useNavigate();
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center px-6 text-center relative overflow-hidden"
      style={{
        background: "linear-gradient(165deg, #1CB0F6 0%, #58CC02 100%)",
      }}
      data-testid="splash-screen"
    >
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.6 }}
        className="flex flex-col items-center gap-6"
      >
        <Mashy mood="celebrate" size={220} />
        <h1 className="font-display text-5xl md:text-6xl text-white drop-shadow-md">Mashy</h1>
        <p className="text-white/95 font-bold text-lg max-w-xs">
          English aur Math seekho — voice ke saath, mazze ke saath!
        </p>
        <motion.button
          whileTap={{ scale: 0.96 }}
          onClick={() => nav("/login")}
          data-testid="splash-start-button"
          className="btn-secondary text-lg px-10 py-4 mt-2"
        >
          Get Started
        </motion.button>
        <button
          onClick={() => nav("/login")}
          data-testid="splash-login-link"
          className="text-white/90 underline text-sm"
        >
          I already have an account
        </button>
      </motion.div>
    </div>
  );
}
